module.exports = __webpack_public_path__ + "static/img/award1.e3dacfd.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award1.png
// module id = kUob
// module chunks = 7